import React from "react";
import { FormattedMessage } from "react-intl";
import { CSSTransition } from "react-transition-group";
var ExamStatus = function(param) {
    var intl = param.intl, exam = param.exam, questionCount = param.questionCount, visible = param.visible, allowNavigation = param.allowNavigation;
    return /*#__PURE__*/ React.createElement(CSSTransition, {
        in: visible,
        timeout: 300,
        classNames: "exam-status",
        mountOnEnter: true,
        unmountOnExit: true
    }, /*#__PURE__*/ React.createElement("div", {
        className: "exam-status"
    }, allowNavigation && /*#__PURE__*/ React.createElement("div", {
        className: "exam-unanswered"
    }, /*#__PURE__*/ React.createElement(FormattedMessage, {
        id: "ui.exam.unanswered",
        defaultMessage: "Unanswered Questions: {count}",
        values: {
            count: exam ? questionCount - exam.answers.length : 0
        }
    })), /*#__PURE__*/ React.createElement("div", {
        className: "exam-center"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "exam-position"
    }, /*#__PURE__*/ React.createElement(FormattedMessage, {
        id: "ui.exam.position",
        defaultMessage: "{position}/{count}",
        values: {
            position: exam ? exam.position + 1 : 0,
            count: questionCount
        }
    }))));
};
export default ExamStatus;
